import React, { memo, useEffect, useCallback, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { CONTEXT } from '../../config';
import styles from './MattsBannerList.module.less';
import {
  loggingADX,
  logNative,
  getUrlByTargetContent,
  hasClass,
  removeClass,
  addClass,
} from '../../utils/utils';
import { useInView } from 'react-intersection-observer';

import { setIframeVisible } from '../../actions/layout';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ data, logInfo }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);

  const [banners, setBanners] = useState(null);
  const maxBannerNum = 8;
  const [ref, inView] = useInView({
    threshold: 1,
  });
  const [refDom, inViewDom] = useInView({
    threshold: 0,
  });

  useEffect(() => {
    // 此类型未验证
    if (inView && logInfo && logInfo.changView) {
      let { pageCardContentId } = data && data.dataList && data.dataList[0];
      if (data && data.dataList && data.dataList.length > 1) {
        pageCardContentId = data.dataList.reduce((total, item) => {
          return `${total}${total ? '||' : ''}${item.pageCardContentId}`;
        }, '');
      }
      logInfo.changView({
        pageCardId: pageCardContentId,
        pageCardTitle: data && data.title,
        rankCode: data && data.dataList && data.dataList[0] && data.dataList[0].code,
        cardType: data && data.cardType,
        org: data && data.dataList && data.dataList[0] && data.dataList[0].org,
      });
    }
  }, [inView]);
  const LOG_ACTION_SOURCE = {
    c_action: `${logInfo.tag}_Four_Format`,
    c_action_btn: `${logInfo.tag}_Four_Format_btn`,
    c_action_adx: `${logInfo.tag}_Four_Format_ADX`,
    p_adx: `${logInfo.tag}_Four_Format_ADX`,
    source: `${logInfo.tag}_Four_Format`,
  };

  // 筛洗数据，去除运营配置数据错误情况
  useEffect(() => {
    if (data && data.dataList) {
      const showBanners = [];
      let hasADXBanner = null;
      data.dataList.forEach(banner => {
        if (
          (banner.targetType === '1' && banner.appInfo) ||
          (banner.targetType === '2' && (banner.targetUrl || banner.targetContent)) ||
          (banner.targetType === '3' && banner.ztId) ||
          (banner.targetType === '5' && banner.targetContent) ||
          (banner.targetType === '11' && banner.targetContent) ||
          (banner.targetType === '12' && banner.targetContent)
        ) {
          showBanners.push(banner);
        }
        // 是否含有adx数据
        if (banner.targetType === '10' && banner.advertCrid && banner.advertUrl) {
          showBanners.push(banner);
          hasADXBanner = banner;
        }
      });
      setBanners(showBanners.slice(0, maxBannerNum));

      // 含有adx数据，则打展示的桩
      if (hasADXBanner) {
        loggingADXPV(hasADXBanner);
      }
    }
  }, [data]);

  const loggingADXPV = useCallback(bannerADX => {
    // 推荐页面ADX banner展示打桩
    dispatch(
      logging({
        category: 'I',
        action: LOG_ACTION_SOURCE.p_adx,
        label: '',
        param2: {
          source: `${LOG_ACTION_SOURCE.source}||${bannerADX.pageCardContentId}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          advertCrid: bannerADX.advertCrid,
          advertUrl: bannerADX.advertUrl,
        },
        param3: bannerADX.bizInfo,
      }),
    );
    if (bannerADX && bannerADX.impTracks) {
      const impTracks = JSON.parse(bannerADX.impTracks);
      loggingADX(impTracks);
    }
  }, []);

  const loggingADXClick = useCallback(bannerADX => {
    // 推荐页面ADX banner点击打桩
    dispatch(
      logging({
        category: 'C',
        action: LOG_ACTION_SOURCE.c_action_adx,
        label: '',
        param2: {
          source: `${LOG_ACTION_SOURCE.source}||${bannerADX.pageCardContentId}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          advertCrid: bannerADX.advertCrid,
          advertUrl: bannerADX.advertUrl,
        },
        param3: bannerADX.bizInfo,
      }),
    );
    if (bannerADX && bannerADX.impTracks) {
      const clickTracks = JSON.parse(bannerADX.clickTracks);
      loggingADX(clickTracks);
    }
  }, []);

  const handleBanner = useCallback(
    bannerInfo => {
      // 推荐页面banner点击打桩
      dispatch(
        logging({
          category: 'C',
          action: LOG_ACTION_SOURCE.c_action,
          label: '',
          param2: {
            source: `${LOG_ACTION_SOURCE.source}||${bannerInfo.pageCardContentId}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
          param3: bannerInfo.bizInfo,
        }),
      );
      if (
        bannerInfo.targetType === '1' ||
        bannerInfo.targetType === '3' ||
        bannerInfo.targetType === '11'
      ) {
        dispatch(
          logPostInfo({
            source_p: `${LOG_ACTION_SOURCE.source}||${bannerInfo.pageCardContentId}`,
            source_pp: logInfoData.source_p,
          }),
        );
        let url = `${CONTEXT}/`;
        if (bannerInfo.targetType && bannerInfo.targetContent) {
          url = getUrlByTargetContent(bannerInfo);
        }
        history.push(url);
      } else if (bannerInfo.targetType === '2') {
        if (bannerInfo.targetUrl) {
          window.open(bannerInfo.targetUrl);
        } else if (bannerInfo.targetContent) {
          try {
            const targetContent = JSON.parse(bannerInfo.targetContent) || {};
            window.open(targetContent.targetUrl);
          } catch (error) {}
        }
      } else if (bannerInfo.targetType === '5' && bannerInfo.targetContent) {
        let targetContent = {};
        try {
          targetContent = JSON.parse(bannerInfo.targetContent);
        } catch (error) {
          logNative(`分析商城URL JSON解析错误:${error}`, error);
        }
        if (targetContent && targetContent.url) {
          dispatch(
            setIframeVisible({
              visible: true,
              url: targetContent.url,
              source: LOG_ACTION_SOURCE.source,
            }),
          );
        }
      } else if (bannerInfo.targetType === '10' && bannerInfo.advertCrid && bannerInfo.advertUrl) {
        loggingADXClick(bannerInfo);
        window.open(bannerInfo.advertUrl);
      } else {
        history.push(`${CONTEXT}/error`);
      }
    },
    [dispatch, logInfoData, history],
  );

  const onMouseOver = useCallback(e => {
    const el = e.currentTarget.getElementsByClassName(styles.matts_item_img)[0];
    addClass(el, styles.image_mouse_in);
  }, []);

  const onMouseLeave = useCallback(e => {
    const el = e.currentTarget.getElementsByClassName(styles.matts_item_img)[0];
    addClass(el, styles.image_mouse_out);
  }, []);

  const onAnimationEnd = useCallback(e => {
    const el = e.currentTarget.getElementsByClassName(styles.matts_item_img)[0];
    if (hasClass(el, styles.image_mouse_out)) {
      removeClass(el, styles.image_mouse_in);
      removeClass(el, styles.image_mouse_out);
    }
  }, []);

  return banners && banners.length > 0 ? (
    <div
      className={inViewDom ? styles.card_cardIn : styles.card_cardOut}
      ref={ref}
      data-item={data.cardType}
    >
      <div
        className={styles.card}
        ref={refDom}
        style={{ height: banners.length <= 4 ? `144px` : `264px` }}
      >
        {inViewDom && (
          <>
            <div className={styles.card_header}>
              <div className={styles.card_header_title}>{data.title}</div>
            </div>
            <div
              className={styles.matts_list}
              style={{ height: banners.length <= 4 ? `120px` : `240px` }}
            >
              {banners.map((item, index) => (
                <div
                  className={styles.matts_item}
                  onClick={() => {
                    handleBanner(item);
                  }}
                  onMouseOver={e => onMouseOver(e)}
                  onMouseLeave={e => onMouseLeave(e)}
                  onAnimationEnd={e => onAnimationEnd(e)}
                  key={index}
                >
                  <div className={styles.matts_item_img_box}>
                    <img className={styles.matts_item_img} src={item.contentImg} />
                  </div>
                  <div className={styles.matts_item_info}>
                    <div className={styles.info_title}>{item.contentTitle}</div>
                    <div className={styles.info_desc}>{item.contentDesc}</div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  ) : (
    ''
  );
});
